import { asError } from "./error"

export interface SafePromise<T> {
    data?: T
    error?: Error
}

export function safePromise<T>(promise: Promise<T>): Promise<SafePromise<T>> {
    return promise.then(data => ({ data })).catch(e => ({ error: asError(e) }))
}

/**
 * Unlike Promise.all(), this function waits for all promises when some of them are rejected.
 */
export function execAndWaitForAll<T>(promises: Promise<T>[]): Promise<T[]> {
    return new Promise<T[]>(async (resolve, reject) => {
        const values: T[] = []
        let error: Error | undefined

        await Promise.all(
            promises.map(promise =>
                promise
                    .then(value => {
                        values.push(value)
                    })
                    .catch(e => {
                        error = asError(e)
                    })
            )
        )

        if (error !== undefined) {
            return reject(error)
        }

        resolve(values)
    })
}
